import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { FadeReveal } from '../FadeReveal/index';
import { Icon } from '../Icon/index';
import { AccordionContext } from './AccordionContext';
import { colors, types, } from './constants';
const borderSize = 1;
const folderColorStyles = {
    [colors.light]: theme.colors.gray100,
    [colors.strong]: theme.colors.gray200,
};
const iconContainerStyles = css `
  margin-left: ${theme.spacing.base};
  display: inline-flex;
`;
const defaultProps = {
    onClick: () => { },
    open: false,
    title: '',
};
const AccordionSection = ({ children, onClick = defaultProps.onClick, open = defaultProps.open, title = defaultProps.title, }) => {
    const { disabled, folderColor, folderType, titleSize, } = useContext(AccordionContext);
    const horizontalPadding = useMemo(() => (folderType === types.indented ? theme.spacing.x3 : 0), [
        folderType,
    ]);
    const titleStyles = useMemo(() => (css `
        ${titleSize === 'medium' && theme.typeStyles.titleSmallStyles}
        ${titleSize === 'large' && theme.typeStyles.titleMediumStyles}
        ${disabled && css `
          color: ${theme.colors.textDisabled};
        `}
      `), [
        disabled,
        titleSize,
    ]);
    const folderContentStyles = useMemo(() => (css `
        margin-bottom: ${theme.spacing.x3};
        padding-left: ${horizontalPadding};
        padding-right: ${horizontalPadding};
      `), [
        horizontalPadding,
    ]);
    const titleContainerStyles = useMemo(() => (css `
      ${styleUtils.buttonReset}
      /* A default color must be set on the button to prevent iOS Safari from overriding the color. */
      color: ${theme.colors.gray700};
      min-height: ${theme.spacing.x12};
      padding-top: ${theme.spacing.x3};
      padding-bottom: ${theme.spacing.x4};
      padding-left: ${horizontalPadding};
      padding-right: ${horizontalPadding};
      display: flex;
      width: 100%;
      text-align: ${folderType === types.centered ? 'center' : 'left'};
      justify-content: ${folderType === types.centered ? 'center' : 'space-between'};
      align-items: center;
      background-color: ${folderColorStyles[folderColor]};
      border-top-color: ${theme.colors.gray300};
      border-top-style: solid;
      border-top-width: ${styleUtils.rem(borderSize)};
      cursor: pointer;
      word-wrap: break-word; 

      ${disabled && css `
        border-color: ${theme.colors.borderDisabled};
        color: ${theme.colors.textDisabled};
        cursor: default;
      `}
      ${disabled && folderColor === 'strong' && css `
        background-color: ${theme.colors.surfaceSystemDisabled};
      `}
    `), [
        disabled,
        horizontalPadding,
        folderColor,
        folderType,
    ]);
    return (_jsxs("div", { children: [_jsxs("button", Object.assign({ css: titleContainerStyles, disabled: disabled, onClick: onClick, type: "button" }, { children: [_jsx("span", Object.assign({ css: titleStyles }, { children: title })), _jsx("span", Object.assign({ css: iconContainerStyles }, { children: _jsx(Icon, { size: titleSize === 'medium' ? 'extraSmall' : 'small', type: open ? 'arrow-up' : 'arrow-down' }) }))] })), children ?
                (_jsx(FadeReveal, Object.assign({ css: folderContentStyles, in: open, unmountOnExit: true }, { children: children })))
                : null] }));
};
const MemoizedAccordionSection = memo(AccordionSection);
export { MemoizedAccordionSection as AccordionSection };
// MC-1068 Temporary hack for Storybook.
export default AccordionSection;
